#import "../../../forms/graphql/fragments/create-rules-fragment.graphql"
#import "../../../forms/graphql/fragments/next-steps-fragment.graphql"
#import "../fragments/wf-field-fragment.graphql"

fragment WfFormFragment on Form {
    id
    name
    status
    htmlUrlPath
    numSubmissions
    numMappedFields
    lastSubmittedTime
    mcfxForm {
        urls
    }
    publishedVersion {
        id
        hasContactFields
        hasAccountFields
        hasLeadFields
        fields {
            ...WfFieldFragment
        }
    }
    createRules {
        ...CreateRulesFragment
    }
    nextSteps {
        ...NextStepsFragment
    }
}
